import useStore from "./_store"
import QCUser from "./_QCUser"
import { useImperativeHandle, useRef, useState } from "react"


export default React.forwardRef((_, ref) => {
	const [isLoading, setIsLoading] = useState(false)
	const currentQCUsers = useStore((state) => state.currentQCUsers)

	if (!ref) ref = useRef(null)

	useImperativeHandle(ref, () => {
		return {
			setIsLoading,
		}
	})

	const loader =
		<div className="grow flex flex-col items-center">
			<div className="lds-ring m-1.5">
				<div></div> 
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>

 

	const content = currentQCUsers ? currentQCUsers.map((qcUser, index) => {
		return <QCUser key={index} user={qcUser} />
	}) : <p>
		No qc users found
	</p>

	const renderedContent = isLoading ? loader : content

	return <>
		<div className="border-grey rounded-primary p-2 border-normal">
			<div className="flex flex-col max-h-[400px] overflow-y-auto min-w-[800px] divide-y divide-grey divide-opacity-50">
				{renderedContent}
			</div>
		</div>
	</>
})